<template>
	<a @click.prevent="" @click="tippytap"  href="#">
		{{ $wait.is('impersonateUser') ? 'Assuming identity...' : 'Assume Identity' }}
	</a>
</template>

<script>
	import { mapState } from 'vuex';
	import { mapWaitingActions } from 'vue-wait';

	export default {
		name: 'ColumnImpersonate',
		props: {
			rowData: {
				type: Object,
				required: true,
			},
			rowIndex: {
				type: Number,
			},
            data: {
                type: Object
            }
		},
		computed: {
			...mapState({
				user: state => state.auth.user,
                event: state => state.event,
			}),
		},
		methods: {
			...mapWaitingActions([
				'impersonateUser',
			]),
            tippytap() {
                console.log(this.event);
                this.impersonateUser(
                    {
                        id: this.rowData.id,
                        event: this.event
                    }
                );
            }
		},
        mounted() {
            console.log("event: " + this.event);
        }
        //Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>
